module.exports = __webpack_public_path__ + "static/media/dolly.1c86eb6d.svg";